import React, { FunctionComponent, useRef } from 'react'
import { DatePicker, DateTimePicker, TimePicker } from "@progress/kendo-react-dateinputs";
import { FieldRenderProps } from '@progress/kendo-react-form';
import { MaskedTextBox } from '@progress/kendo-react-inputs';
import Time from '../../Common/Time';

export const TimeField: FunctionComponent<FieldRenderProps> = props => {
  const { field, value, companyId, ...others } = props;
  const defVal = field?.VALUES?.length > 0 ? new Date(field?.VALUES[0]) : undefined //props.ConfigSettings?.Default === "2" ? new Date(Date.parse(props.ConfigSettings?.DefaultValue)) : (props.ConfigSettings?.Default === "1" ? new Date() : null);
  const fieldChanged = (e) => {
    let fieldChange = { ...field, VALUES: [e.value] }
    props.onChange({ value: fieldChange });
  }
  return (
    <div>
      <Time {...others} onChange={fieldChanged} value={defVal} />
    </div>

  )
}


